var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`icon-2`, _vm.className || ``]},[_c('div',{staticClass:"overlap-group-10"},[_c('bg',{attrs:{"src":_vm.bgProps.src,"className":_vm.bgProps.className}}),_c('img',{staticClass:"shape-6",attrs:{"src":"/otplanding/shape-4@2x.png","alt":"Shape"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }